import { render } from "./Reminder.vue?vue&type=template&id=4f23a096&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"

import "./Reminder.vue?vue&type=style&index=0&id=4f23a096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f23a096"]])

export default __exports__